import React, { useState ,useEffect} from "react";
import {
  Box,
  Button,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  useColorModeValue,
} from "@chakra-ui/react";
import Heading from "../../../components/Heading";
import LiveStreamList from "./LiveStreamList";
import { AiOutlineSearch } from "react-icons/ai";
import { FaPodcast } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CreateLivestreamModal from "./CreateLivestremModal";
import useSmallScreen from "../../../components/useSmallScreen";
  import { useGetState } from "../../../context/useGetState";
  import axios from "axios";

function LiveStreaming() {
  const token = sessionStorage.getItem("#f8WEB#");
  console.log('token-->',token)
  const config = {
    headers: { Authorization: `Bearer ${token}` }
};
  const [livestream, setLivestream] = React.useState(null);
  const baseURL = "http://104.237.2.75/api/list";
  const baseURL2 = "https://f8.codester.dev/api/live-streams";
  React.useEffect(() => {
    axios.get(baseURL).then((response) => {
      // setLivestream(response?.data);
    });
    axios.get(baseURL2,config).then((response) => {
      console.log('livestream-->',response?.data?.data)
      setLivestream(response?.data?.data);
    });
  }, []);
  const redColor = useColorModeValue("#FF686B", "#FF4246");
  const roundColor = useColorModeValue("#0076FF", "#0076FF");
  const { state } = useGetState();

  const navigate = useNavigate();
  
  const [smallScreen] = useSmallScreen();
  console.log('livestream',livestream)
  return (
    <Stack>
      <Stack
        direction={["column", "row"]}
        alignItems="center"
        justifyContent={"space-between"}
        mb="20px"
        w={smallScreen ? "100%" : "unset"}
      >
        <Stack
          direction={"row"}
          alignItems="center"
          spacing={"20px"}
          justifyContent={["space-between", "unset"]}
          w={smallScreen ? "100%" : "unset"}
        >
          <Heading>Live Streams</Heading>

          <CreateLivestreamModal />
        </Stack>
        
        <Stack
          direction={"row"}
          alignItems="center"
          w={["100%", "unset"]}
          flexFlow={["row-reverse", "unset"]}
          mt={["25px !important", "unset"]}
          justifyContent={["space-between", "unset"]}
        >
          <Box
            ml={["10px !important", "unset"]}
            border={`1px solid ${roundColor}`}
            borderRadius="50%"
            p="5px"
          >
            
          </Box>
          <InputGroup>
            <InputRightElement
              pointerEvents="none"
              children={
                <Stack
                  mt="10px"
                  borderRadius="50%"
                  w="40px"
                  h="40px"
                  bg={redColor}
                  justifyContent={"center"}
                  alignItems="center"
                >
                  <AiOutlineSearch fontSize={"1.5em"} color="#fff" />
                </Stack>
              }
            />
            <Input
              size="lg"
              type="text"
              p={"10px"}
              placeholder="Search Stream"
              borderRadius={"20px"}
              _placeholder={{ fontSize: ".8em" }}
              boxShadow="2px 2px 9px 0px #80808021"
            />
          </InputGroup>
        </Stack>
      </Stack>
      <LiveStreamList  post={livestream} />
    </Stack>
  );
}

export default LiveStreaming;
